var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"ui segment z-dz"},[_c('div',{staticClass:"ui inverted dimmer",class:{ active: _vm.uploadIsActive }},[_c('div',{staticClass:"ui primary elastic loader"},[_vm._v("Datei wird hochgeladen")])]),_c('p',[_vm._v("Hochzuladende Datei hierher ziehen")])])
}
var staticRenderFns = []

export { render, staticRenderFns }